import { render, staticRenderFns } from "./ObjectStoreSelectButtonDescribePopover.vue?vue&type=template&id=575164f2"
import script from "./ObjectStoreSelectButtonDescribePopover.vue?vue&type=script&setup=true&lang=ts"
export * from "./ObjectStoreSelectButtonDescribePopover.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports